import { Button, Stack, Typography } from "@mui/material";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.UnassignedMerchants.AssignDialog;

type Props = {
  isPending: boolean;
  isSubmitDisabled: boolean;
  onCancel: () => void;
};

export const AssignHunterDialogActions = ({
  isPending,
  isSubmitDisabled,
  onCancel,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={1} alignItems="flex-end">
      <Typography variant="caption" color="text.secondary">
        {t(RESOURCES.AssignWarning)}
      </Typography>
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Button
          onClick={onCancel}
          variant="text"
          disabled={isPending}
          type="button"
        >
          {t(RESOURCES.CancelButton)}
        </Button>
        <PrimaryButton
          type="submit"
          disabled={isSubmitDisabled}
          isLoading={isPending}
          variant="contained"
          color="primary"
        >
          {t(RESOURCES.AssignButton)}
        </PrimaryButton>
      </Stack>
    </Stack>
  );
};
